type AnuladoCarrier = {
  anulado?: boolean | string | number;
  Anulado?: boolean | string | number;
};

type PackageCarrier = AnuladoCarrier & {
  packageNumber?: string;
  PackageNumber?: string;
};

export function isSparePartAnulado(sp: AnuladoCarrier | null | undefined): boolean {
  if (!sp) {
    return false;
  }

  const raw = sp.anulado ?? sp.Anulado;
  if (raw === true || raw === 1) {
    return true;
  }
  if (typeof raw === 'string') {
    const normalized = raw.trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'si' || normalized === 'sí' || normalized === 'yes';
  }
  return false;
}

export function getSparePartPackageNumber(sp: PackageCarrier | null | undefined): string {
  return (sp?.packageNumber ?? sp?.PackageNumber ?? '').trim();
}

export function packageHasAnuladoSparePart(spareParts: PackageCarrier[] | null | undefined): boolean {
  return (spareParts || []).some(sp => isSparePartAnulado(sp));
}

export function getPackageNumbersWithAnulado(spareParts: PackageCarrier[] | null | undefined): Set<string> {
  const blocked = new Set<string>();
  for (const sparePart of spareParts || []) {
    const packageNumber = getSparePartPackageNumber(sparePart);
    if (packageNumber && isSparePartAnulado(sparePart)) {
      blocked.add(packageNumber);
    }
  }
  return blocked;
}

export function getPackageBlockedByAnuladoMessage(packageNumber: string): string {
  return `El paquete ${packageNumber} no puede cargarse porque tiene al menos un repuesto marcado como Anulado.`;
}

export function excludeSparePartsFromPackagesWithAnulado<T extends PackageCarrier>(
  spareParts: T[] | null | undefined
): T[] {
  const blockedPackages = getPackageNumbersWithAnulado(spareParts);
  if (blockedPackages.size === 0) {
    return [...(spareParts || [])];
  }

  return (spareParts || []).filter(sp => {
    const packageNumber = getSparePartPackageNumber(sp);
    return !packageNumber || !blockedPackages.has(packageNumber);
  });
}
